export class AudioPlayback {
    constructor(ctx, rate) {
        this.ctx = ctx;
        this.rate = rate;
        this.playhead = 0;
        this.sources = new Set();

        this.gain = ctx.createGain();
        this.gain.gain.value = 1;

        // Route through a MediaStreamDestination + <audio> so the browser's
        // echo canceller (enabled on getUserMedia) can use this output as a
        // reference signal — plain ctx.destination is invisible to AEC.
        this.dest = ctx.createMediaStreamDestination();
        this.gain.connect(this.dest);
        this.el = new Audio();
        this.el.srcObject = this.dest.stream;
        this.el.autoplay = true;
        void this.el.play().catch(() => {
            // play() may reject if no user gesture preceded; the chain still
            // works once the gesture lands (we're invoked from the mic click).
        });
    }

    enqueueBase64Pcm16(b64) {
        const bin = atob(b64);
        const len = bin.length / 2;
        if (len === 0) return;
        const buf = this.ctx.createBuffer(1, len, this.rate);
        const channel = buf.getChannelData(0);
        for (let i = 0; i < len; i++) {
            const lo = bin.charCodeAt(i * 2);
            const hi = bin.charCodeAt(i * 2 + 1);
            let s = (hi << 8) | lo;
            if (s & 0x8000) s -= 0x10000;
            channel[i] = s / 0x8000;
        }
        const src = this.ctx.createBufferSource();
        src.buffer = buf;
        src.connect(this.gain);
        const now = this.ctx.currentTime;
        const start = Math.max(now + 0.005, this.playhead);
        src.start(start);
        this.playhead = start + buf.duration;
        this.sources.add(src);
        src.onended = () => this.sources.delete(src);
    }

    flush() {
        this.playhead = 0;
    }

    hardStop() {
        const now = this.ctx.currentTime;
        try {
            this.gain.gain.cancelScheduledValues(now);
            this.gain.gain.setValueAtTime(this.gain.gain.value, now);
            this.gain.gain.linearRampToValueAtTime(0, now + 0.01);
        } catch {
            // ignore
        }
        for (const src of this.sources) {
            try {
                src.stop();
            } catch {
                // already stopped
            }
        }
        this.sources.clear();
        this.playhead = 0;
        try {
            this.gain.gain.setValueAtTime(0, now + 0.01);
            this.gain.gain.linearRampToValueAtTime(1, now + 0.04);
        } catch {
            // ignore
        }
    }
}
